import axios from 'axios'

export default () => {
    const instance = axios.create({
        // baseURL: `http://localhost/phpstormprojects/geonovation/kaartviewer/admin/rest/auth`,
        baseURL: `../admin/rest/auth`,
        withCredentials: false,
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    });
    instance.interceptors.response.use(function (response) {
        return response;
    }, (error) => {
        // Nooit doorsturen naar een API-endpoint: /admin/rest/auth/myself geeft
        // JSON terug, waardoor de gebruiker op een kale JSON-pagina belandt in
        // plaats van in het menu.
        const status = error.response ? error.response.status : null;

        /* eslint-disable no-console */
        console.error('Auth API mislukt' + (status ? ' (status ' + status + ')' : ' (netwerk/CORS)'), error);

        // Alleen bij een echte authenticatiefout naar de loginpagina.
        if (status === 401 || status === 403) {
            window.location = '../admin/login?redirect=../menu/index.html';
            // De navigatie loopt al; keten stilhouden zodat er niets meer rendert.
            return new Promise(() => {});
        }

        // Overige fouten (bijv. een 500 tijdens het SSO-inloggen): het menu
        // anoniem laten renderen in plaats van de gebruiker ruwe JSON in te
        // sturen. Een leeg object zorgt ervoor dat getLoggedInUser() de
        // gebruiker als niet-ingelogd behandelt.
        return Promise.resolve({data: {}, status: status});
    });
    return instance;
}
